import * as types from "./mutation_types";

export default {
  [types.RELANCE_SEND_SET_ERROR](state, error) {
    Object.assign(state, { error });
  },

  [types.RELANCE_SEND_TOGGLE_LOADING](state) {
    Object.assign(state, { isLoading: !state.isLoading });
  },
};
